import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from "../components/Login"
import Regist from "../components/Regist"
import Home from "../components/Home.vue"
import User from "../components/user/User.vue"
import UserList from "../components/user/UserList.vue"
import rmaList from "../components/user/rmaList.vue"
import rmaAdd from "../components/rma/add.vue"
import rmaEdit from "../components/rma/edit.vue"
import emAdd from "../components/email/add.vue"
import setAdd from "../components/sysset/add.vue"
import adAdd from "../components/addressset/add.vue"
Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect:"/rmaList",
        name: 'rmaList',
        component: rmaList
    },
  {
    path: '/login',
    name: 'Login',
    component: Login,
      meta: {
          title: 'Welcome to Sunwave’s RMA Process System'
      }
  },

  {
    path: '/regist',
    name: 'Regist',
    component: Regist
  },



  {
    path: '/home',
    redirect:"/rmaList",
    component: Home,
    children:[
        {path:"/user",component:User},
        {path:"/userList",component:UserList},
        {path:"/rmaList/:close",component:rmaList},
        {path:"/rmaList",component:rmaList,redirect:"/rmaList/0",},
        {path:"/rma/add",component:rmaAdd},
        {path:"/rma/edit/:id",component:rmaEdit},
        {path:"/em/add",component:emAdd},
        {path:"/set/add",component:setAdd},
        {path:"/ad/add",component:adAdd},
        ]
  },
]

const router = new VueRouter({
  routes
})
router.beforeEach((to,from,next)=>{

    const expire_time=localStorage.getItem("expire_time");
    if ((Date.now() - expire_time > 3600*48*1000) || !expire_time) {
        localStorage.removeItem("token");
        localStorage.removeItem("username");
        localStorage.removeItem("expire_time");
    }
    const token=localStorage.getItem("token");

    if(to.path==="/login"){
        if(token){
            next("/userList");
            alert("已登录");
        }else {
            next();
        }

    }else if(to.path==="/regist"){
        localStorage.removeItem("token");
        next();

    }else {
        if(token){

            next();
        }else {
            next("/login");
        }
    }







})
export default router
